import { openBlock, createElementBlock, createElementVNode, normalizeClass, toDisplayString, createCommentVNode } from "vue";
/* empty css               */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.mjs";
const _sfc_main = {
  name: "GenericPrice",
  props: {
    id: {
      type: String,
      required: true
    },
    price: {
      type: Object,
      required: true
    }
  },
  computed: {
    showCompare() {
      return !this.price.map && this.price.sale && this.price.value < this.price.compValue;
    }
  },
  methods: {
    formatPrice(price) {
      return price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
const _hoisted_1 = {
  class: "inline-price"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  key: 0,
  class: "pdp-sr-only"
};
const _hoisted_4 = ["id"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", _hoisted_1, [createElementVNode("span", {
    id: $props.id,
    class: normalizeClass(["inline-price__price-entry", {
      "inline-price__price-entry--sale": $props.price.sale
    }])
  }, " $" + toDisplayString($options.formatPrice($props.price.value)), 11, _hoisted_2), $options.showCompare ? (openBlock(), createElementBlock("span", _hoisted_3, "Compared To")) : createCommentVNode("", true), $options.showCompare ? (openBlock(), createElementBlock("span", {
    key: 1,
    id: `${$props.id}-compare`,
    class: "inline-price__price-entry--compare"
  }, " $" + toDisplayString($options.formatPrice($props.price.compValue)), 9, _hoisted_4)) : createCommentVNode("", true)]);
}
const GenericPrice = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-5e87beee"]]);
export {
  GenericPrice as default
};
//# sourceMappingURL=GenericPrice.mjs.map
